import { render, staticRenderFns } from "./FavoriteChip.vue?vue&type=template&id=a3090a78&scoped=true&"
import script from "./FavoriteChip.vue?vue&type=script&lang=js&"
export * from "./FavoriteChip.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteChip.vue?vue&type=style&index=0&id=a3090a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3090a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3090a78')) {
      api.createRecord('a3090a78', component.options)
    } else {
      api.reload('a3090a78', component.options)
    }
    module.hot.accept("./FavoriteChip.vue?vue&type=template&id=a3090a78&scoped=true&", function () {
      api.rerender('a3090a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/ui/FavoriteChip.vue"
export default component.exports